import BrandNameRemapping from '../lib/BrandNameRemapping.json';

export const remapBrandName = (brandName: string): string => {
  const remappedName =
    BrandNameRemapping[brandName as keyof typeof BrandNameRemapping] ||
    brandName;
  return remappedName;
};
